import React$1, { PureComponent } from 'react';
import { layer } from '../../../shared.js';
import { classNames } from '../../../../utilities/css.js';
import { PositionedOverlay as PositionedOverlay$1 } from '../../../PositionedOverlay/PositionedOverlay.js';
import styles from '../../Tooltip.scss.js';

class TooltipOverlay extends PureComponent {
  constructor(...args) {
    super(...args);

    this.renderOverlay = () => {
      var {
        active,
        activator,
        preferredPosition = 'below',
        preventInteraction
      } = this.props;
      return /*#__PURE__*/React$1.createElement(PositionedOverlay$1, {
        active: active,
        activator: activator,
        preferredPosition: preferredPosition,
        preventInteraction: preventInteraction,
        render: this.renderTooltip
      });
    };

    this.renderTooltip = overlayDetails => {
      var {
        measuring,
        desiredHeight,
        positioning
      } = overlayDetails;
      var {
        id,
        children,
        light
      } = this.props;
      var containerClassName = classNames(styles.Tooltip, light && styles.light, measuring && styles.measuring, positioning === 'above' && styles.positionedAbove);
      var contentStyles = measuring ? undefined : {
        minHeight: desiredHeight
      };
      return /*#__PURE__*/React$1.createElement("div", Object.assign({
        className: containerClassName
      }, layer.props), /*#__PURE__*/React$1.createElement("div", {
        className: styles.Wrapper
      }, /*#__PURE__*/React$1.createElement("div", {
        id: id,
        role: "tooltip",
        className: styles.Content,
        style: contentStyles
      }, children)));
    };
  }

  render() {
    var markup = this.props.active ? this.renderOverlay() : null;
    return markup;
  } // eslint-disable-next-line @shopify/react-no-multiple-render-methods


}

export { TooltipOverlay };
